import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import { getConsent } from "../utils/cookie-consent"
import Cookies from "universal-cookie"

const COOKIE_PREFIX = "alert-"

export const query = graphql`
  fragment AlertBarFields on DatoCmsAlertBar {
    id
    text
    icon
    closable
    url
    urlText
  }
`

const AlertBar = ({
  id,
  text,
  closable,
  url,
  urlText,
}: Queries.AlertBarFieldsFragment) => {
  const [showBar, setShowBar] = useState(false)

  const cookies = new Cookies()
  const cookieName = COOKIE_PREFIX + encodeURIComponent(id)

  const onHide = () => {
    setShowBar(false)
    const currentConsent = getConsent()
    if (currentConsent.functionality_storage) {
      // If user has given consent to use cookies, save choice for a year
      cookies.set(cookieName, true, {
        path: "/",
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
      })
    }
  }

  useEffect(() => {
    const cookieValue = cookies.get(cookieName)
    // If we have a cookie, the user has has choose to hide the bar previously
    if (cookieValue) {
      setShowBar(false)
    } else {
      setShowBar(true)
    }
  }, [])

  if (!showBar) {
    return null
  }

  return (
    <div className="c-alert-bar u-center-align">
      <div className="c-alert-bar__content u-flex u-horizontal-center">
        <p className="c-alert-bar__text">{text}</p>
        {url && urlText && (
          <a className="c-link -white" href={url}>
            {urlText}
          </a>
        )}
      </div>
      {closable && (
        <button className="c-alert-bar__close" onClick={onHide}>
          <span className="u-visually-hidden">Close alert</span>
        </button>
      )}
    </div>
  )
}
export default AlertBar
